interface ITextWidgetProps {
  text: string;
}

export interface ITextWidget {
  id: string;
  modalType: "text";
  type: "text";
  text: string;
}

const TextWidget = ({text}: ITextWidgetProps) => {
  return <div className="textWidget">
    <p className="textWidget-labelWrapper">{text}</p>
  </div>;
};

export default TextWidget;